import { render, staticRenderFns } from "./DynamicLink.vue?vue&type=template&id=4ea7cf1f&scoped=true"
import script from "./DynamicLink.vue?vue&type=script&lang=js"
export * from "./DynamicLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea7cf1f",
  null
  
)

export default component.exports